import Vue from 'vue'
import './plugins/fontawesome'
import App from './App.vue'
import router from './router'

import titleMixin from './mixins/titleMixin'
import VueMeta from 'vue-meta'

Vue.config.productionTip = false

Vue.mixin(titleMixin)

Vue.use(VueMeta)

var allaSidor = {
    Steg: 0,
    KritiskUppdatering: 200408,
    PresensAvSein: {'dittSvar':[],'dinRattning':[]},
    AdjektivStarkSvagBöjning : {'dittSvar':[],'dinRattning':[]},
    PresensAvSvagaVerb : {'dittSvar':[],'dinRattning':[]},
    Ackusativobjekt : {'dittSvar':[],'dinRattning':[]},
    AckusativOchDativobjekt : {'dittSvar':[],'dinRattning':[]},
    AdjektivKomparation : {'dittSvar':[],'dinRattning':[]},
    Genitiv : {'dittSvar':[],'dinRattning':[]},
    PerfektAvSvagaVerb : {'dittSvar':[],'dinRattning':[]},
    PerfektAvStarkaVerb : {'dittSvar':[],'dinRattning':[]},
    PerfektMedSeinSomHjalpverb : {'dittSvar':[],'dinRattning':[]},
    PerfektBlandadeOvningar: {'dittSvar':[],'dinRattning':[]},
    PresensAvHaben: {'dittSvar':[],'dinRattning':[]},
    PresensAvStarkaVerb: {'dittSvar':[],'dinRattning':[]},
    AlsWannWenn: {'dittSvar':[],'dinRattning':[]},
    ImperfektAvSvagaVerb: {'dittSvar':[],'dinRattning':[]},
    ImperfektAvStarkaVerb: {'dittSvar':[],'dinRattning':[]},
    DerOrd: {'dittSvar':[],'dinRattning':[]},
    DasOrd: {'dittSvar':[],'dinRattning':[]},
    DieOrd: {'dittSvar':[],'dinRattning':[]},
    GenusOchPlural: {'dittSvar':[],'dinRattning':[]},
    ObWenn: {'dittSvar':[],'dinRattning':[]},
    Subjunktioner: {'dittSvar':[],'dinRattning':[]},
    VerbSomStyrDativ: {'dittSvar':[],'dinRattning':[]},
    PrepositionerSomStyrAckusativ: {'dittSvar':[],'dinRattning':[]},
    PrepositionerSomStyrDativ: {'dittSvar':[],'dinRattning':[]},
    PrepositionerSomStyrAckusativEllerDativ: {'dittSvar':[],'dinRattning':[]},
    PrepositionerBlandadeOvningar: {'dittSvar':[],'dinRattning':[]},
    RelativaPronomenNominativ: {'dittSvar':[],'dinRattning':[]},
    RelativaPronomenAllaKasus: {'dittSvar':[],'dinRattning':[]},
    PrepositionerSpeciellaVerbuttryck: {'dittSvar':[],'dinRattning':[]},
    Pronominaladverb: {'dittSvar':[],'dinRattning':[]},
    ModalaHjalpverb: {'dittSvar':[],'dinRattning':[]},
    PossessivaPronomen: {'dittSvar':[],'dinRattning':[]},
    DarforDarforAtt: {'dittSvar':[],'dinRattning':[]},
    SehrVielViele: {'dittSvar':[],'dinRattning':[]},
    InfinitivPerfekt: {'dittSvar':[],'dinRattning':[]}
};

if (localStorage.getItem("done") === null) {
    window.document.done = allaSidor;
    localStorage.setItem("done", JSON.stringify(window.document.done));
} else {
    window.document.done = JSON.parse(localStorage.getItem("done"));

    if (isNaN(window.document.done.KritiskUppdatering) || window.document.done.KritiskUppdatering < 200408) {
        window.document.done = allaSidor;
        localStorage.setItem("done", JSON.stringify(window.document.done));
    } else {

        for(var onskadKey in allaSidor) {
            var fannsDen = false;
            for(var befintligKey in window.document.done) {
                if (onskadKey === befintligKey ) {
                    fannsDen = true;
                }
            }
            if (fannsDen === false) {
                window.document.done[onskadKey] = {'dittSvar':[],'dinRattning':[]};
            }
        }
    }


}
window.onbeforeunload = function()
   {
       localStorage.setItem("done", JSON.stringify(window.document.done));
   };

new Vue({
    router,
  render: h => h(App),
}).$mount('#app')
